import { withTranslation, WithTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Odds from 'shared/components/odds/container';
import { BETSType, CouponState, EventType, State } from 'shared/interface';
import { addBet } from 'shared/store/coupon.action';
import { setAllBets } from 'shared/util/utility';

import CashoutIcon from 'assets/images/CashoutIcon.svg?react';
import InfoButtonIcon from 'assets/images/InfoButtonIcon.svg?react';
import { OddsType } from 'features/eventLive/interface/interface';
import { useState } from 'react';
import CashoutAvaibleDialog from 'shared/components/dialog/cashoutAvaibleDialog';
import GameTypeInfoDialog from 'shared/components/dialog/gameTypeInfoDialog';
import useClickOutside from 'shared/hooks/useClickOutside';

interface EventLiveCardViewProps extends WithTranslation {
	gameDetail: any;
	className?: string;
	oddsArray?: OddsType[];
	isLive?: boolean;
	eventViewOdds?: boolean;
}

export type DialogTypes = 'cashout' | 'gameType';

const EventLiveCardView = (props: EventLiveCardViewProps) => {
	const { gameDetail, t, eventViewOdds } = props;
	const bets = useSelector((state: State) => state.coupon.bets);
	const analytics = useSelector((state: State) => state.coupon.analytics);
	const coupon = useSelector<State, CouponState>((state) => state.coupon);
	const dispatch = useDispatch();
	const addBetDispatch = (params: BETSType) => {
		dispatch(addBet(params));
	};

	const handleDialogState = (type: DialogTypes, isOpen: boolean) => {
		switch (type) {
			case 'cashout':
				setOpenCashoutInfo(isOpen);
				break;
			case 'gameType':
				setOpenGameTypeInfo(isOpen);
				break;
		}
	};

	const gameTypeDialogRef = useClickOutside(() => handleDialogState('gameType', false), 'click');

	const [openGameTypeInfo, setOpenGameTypeInfo] = useState(false);
	const [openCashoutInfo, setOpenCashoutInfo] = useState(false);

	const onClickOdds = (odds: any) => {
		const betObj = {
			outcomeId: odds.outcomeId,
			outcomeOdds: odds.outcomeOdds,
			outcomeName: odds.outcomeName,
			sportId: gameDetail.sportId,
			eventId: gameDetail.eventId,
			eventType: props.isLive ? EventType.LIVE : EventType.PREMATCH,
			gameName: gameDetail.gameName,
			gameType: gameDetail.gameType,
			categoryId: gameDetail.categoryId,
			gameId: gameDetail.gameId,
			eventName: gameDetail.eventName,
			eventStart: gameDetail.eventStart,
			league: `${gameDetail.sportName} / ${gameDetail.parentName} / ${gameDetail.categoryName}`,
			selectedBet: true,
			banker: false,
			isLive: props.isLive || false,
			combinationType: gameDetail.combinationType,
		};
		addBetDispatch({ ...bets, ...setAllBets(bets, betObj, dispatch, coupon, analytics, t) });
	};

	const returnCheck = (id: number) => {
		const outcome: any = (props.oddsArray || []).find((item) => item.outcomeId === id);
		return !!outcome && outcome.isUpdate;
	};

	return (
		<>
			<div className={`pre-match__card ${props.className ? props.className : ''}`}>
				<div className="flex justify__content--between">
					<p className="game-name-card">{gameDetail.gameName}</p>
					<span className="width--auto height--17 mt---2">
						{gameDetail.isCashoutAvailable && <CashoutIcon className="cashout-icon" onClick={() => handleDialogState('cashout', true)} />}
						{!props.isLive && (
							<InfoButtonIcon
								onClick={() => handleDialogState('gameType', true)}
								className="warning--icon fill--primary width--17 height--17 pointer"
							/>
						)}
					</span>
				</div>
				{props.isLive ? (
					<Odds
						animateOdds={false}
						noMaxHeightOdds={true}
						key={gameDetail.eventId}
						data={{ ...gameDetail, outcomesLength: gameDetail.outcomes?.length, eventType: EventType.LIVE, isDetailedView: true }}
						returnCheck={returnCheck}
						onClickOdds={onClickOdds}
						eventViewOdds={eventViewOdds}
					/>
				) : (
					<Odds
						noMaxHeightOdds={true}
						expandOdds={false}
						data={{ ...gameDetail, outcomesLength: gameDetail.outcomes?.length, isDetailedView: true }}
						onClickOdds={onClickOdds}
						eventViewOdds={eventViewOdds}
					/>
				)}
			</div>
			<GameTypeInfoDialog
				openGameTypeInfo={openGameTypeInfo}
				handleDialogState={handleDialogState}
				infoText={t(`gameName_${gameDetail.gameType}`)}
				gameTypeDialogRef={gameTypeDialogRef}
			/>
			<CashoutAvaibleDialog openCashoutInfo={openCashoutInfo} handleDialogState={handleDialogState} />
		</>
	);
};

export default withTranslation()(EventLiveCardView);
